import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import mockedPermissions from "logic/permissions/mocked";
import { SearchForm, Select } from "components/common";
import SharedEntitiesQueryHelper from "./SharedEntitiesQueryHelper";
const StyledSearchForm = styled(SearchForm)`
  display: inline-block;

  margin-bottom: 10px;
  margin-right: 15px;
`;
const Filters = styled.div`
  display: inline-block;
  vertical-align: top;

  margin-right: 15px;
  margin-bottom: 10px;
`;
const SelectWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  vertical-align: top;

  width: 260px;
  margin-left: 10px;
  margin-right: 10px;

  white-space: nowrap;
`;
const StyledSelect = styled(Select)`
  width: 300px;
  margin-left: 10px;
`;
const entityTypeOptions = Object.entries(mockedPermissions.availableEntityTypes).map(([key, value]) => ({
  label: value,
  value: key
}));
const capabilityOptions = Object.entries(mockedPermissions.availableCapabilities).map(([key, value]) => ({
  label: value,
  value: key
}));
const SharedEntitiesFilter = ({ onSearch, onFilter }) => {
  const { t } = useTranslation("users");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    StyledSearchForm,
    {
      onReset: () => onSearch(""),
      onSearch,
      queryHelpComponent: /* @__PURE__ */ React.createElement(SharedEntitiesQueryHelper, null),
      topMargin: 0
    }
  ), /* @__PURE__ */ React.createElement(Filters, null, /* @__PURE__ */ React.createElement(SelectWrapper, null, /* @__PURE__ */ React.createElement("label", { htmlFor: "entity-type-select" }, t("permissions.shared_entities.entity_type")), /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      inputId: "entity-type-select",
      onChange: (entityType) => onFilter("entity_type", entityType),
      options: entityTypeOptions,
      placeholder: t("permissions.shared_entities.filter_entity_types")
    }
  )), /* @__PURE__ */ React.createElement(SelectWrapper, null, /* @__PURE__ */ React.createElement("label", { htmlFor: "capability-select" }, t("permissions.shared_entities.capability")), /* @__PURE__ */ React.createElement(
    StyledSelect,
    {
      inputId: "capability-select",
      onChange: (capability) => onFilter("capability", capability),
      options: capabilityOptions,
      placeholder: t("permissions.shared_entities.filter_capabilities")
    }
  ))));
};
export default SharedEntitiesFilter;
